import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef, EventEmitter,
  Inject, Input, Output,
  Renderer2,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { DOCUMENT } from '@angular/common';


@Component({
  selector: 'pgs-custom-modal',
  templateUrl: './custom-modal.component.html',
  styleUrls: ['./custom-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomModalComponent {

  @Input() customBackdropStyles: { [s: string]: string | number };
  @Input() customModalStyles: { [s: string]: string | number };
  @Output() customCallbackClose: EventEmitter<any> = new EventEmitter<void>();
  @ViewChild('modal', { static: false }) public modal: ElementRef;

  public data?: any;
  public isVisible: boolean;

  constructor(
    private readonly renderer: Renderer2,
    private readonly changeDetector: ChangeDetectorRef,
    @Inject(DOCUMENT) private readonly document: Document
  ) {
    this.data = null;
    this.isVisible = false;
  }

  public open(data?: any): void {
    this.data = data ?? null;
    console.log({data});
    this.isVisible = true;
    this.changeDetector.detectChanges();
    // this.renderer.addClass(this.modal.nativeElement, 'show');
    // this.renderer.appendChild(this.document.body, this.modal.nativeElement);
  }

  public close(): void {
    this.customCallbackClose.emit('close');
    this.data = null;
    this.isVisible = false;
    this.changeDetector.detectChanges();
    // this.renderer.removeChild(this.document.body, this.modal.nativeElement);
    // this.renderer.removeClass(this.modal.nativeElement, 'show');
  }

  public setData(data: any): void {
    this.data = data;
    this.changeDetector.detectChanges();
  }
}
